<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols='12' md='6'>
          <day-button
            @prev='prevWeek'
            @next='nextWeek'
            @today='thisWeek'
          ></day-button>
          <v-card
            v-for='(entry, index) in entries'
            :key='index'
            class='mt-1 white--text'
            outlined
            flat
            :color='getColor(entry)'
            @click='openEntry(entry)'
          >
            <div class="d-flex justify-space-between">
              <div>
                <v-card-title>{{ getDay(entry.date) }}</v-card-title>
                <v-card-subtitle class='flex-no-wrap white--text'>{{ entry.date | dateNoYear }}</v-card-subtitle>
              </div>
              <v-card-title align='end' style='word-break: normal;'>{{ entry.id ? (entry.hours_worked.toFixed(2) + ' hrs') : 'entry missing'}}</v-card-title>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <entry-basics-dialog
      :showDialog='showDialog'
      :entry='entryCopy'
      @cancel='showDialog = false'
      @returnToDashboard='returnToDashboard'
    ></entry-basics-dialog>
  </div>
</template>

<script>
import DayButton from './DayButton'
import moment from 'moment'
import _ from 'lodash'
import timesheetsAPI from '../../api/timesheets'
import timesheetServices from '../../services/timesheets'
// import miscServices from '@/services/misc'
// import formRules from '@/mixins/formRules'
import EntryBasicsDialog from '../../components/EntryBasicsDialog'

export default {
  name: 'timesheets-dashboard',
  data: () => ({
    isLoading: true,
    showDialog: false,
    date: null,
    entryCopy: {},
    days: [],
    entries: []
  }),
  mounted () {
    this.thisWeek()
  },
  computed: {
    today () {
      return moment().format('YYYY-MM-DD').toString()
    },
    yesterday () {
      return moment().subtract(1, 'days').format('YYYY-MM-DD').toString()
    },
    profile () {
      return this.$store.state.auth.profile
    }
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.getWeekFor(this.date)
      this.isLoading = false
    },
    async getWeekFor(date) {
      this.entries = []
      let from = moment(date).subtract(6, 'days').format('YYYY-MM-DD').toString() 
      this.days = await timesheetServices.weekDays(from, date)
      let tmp = await timesheetsAPI.getTimesheetEntries(from, date, this.profile.id)
      this.days.forEach(d => {
        let entry = _.find(tmp, ['date', d])
        if (entry) {
          this.entries.unshift(entry)
        } else {
          this.entries.unshift({
            // setting default values for blank entires being passed into the dialog component
            'date': d,
            'employee': this.profile.id,
            'start': this.profile.default_start,
            'end': this.profile.default_end,
            'had_lunch': true,
            'kms': null
          })
        }
      })
    },
    getColor(entry) {
      if (!entry.id) {
        return 'amber darken-3'
      } else if (entry.hours_left_to_assign !== 0) {
        return 'purple'
      } else if (entry.start === entry.end) {
        return 'grey'
      }
      return 'info'
    },
    getDay(date){
      return moment(date).format('dddd').toString()
    },
    openEntry(entry) {
      if (entry.id) {
        this.$router.push({ name: 'TimesheetEntry', params: { id: entry.id } })
      } else {
        this.entryCopy = _.cloneDeep(entry)
        this.showDialog = true
      }
    },
    returnToDashboard() {
      this.showDialog = false
      this.getData()
    },
    thisWeek() {
      this.date = this.today
      this.getData()
    },
    nextWeek() {
      this.date = moment(this.date).add(1, 'weeks').format('YYYY-MM-DD').toString()
      this.getData()
    },
    prevWeek() {
      this.date = moment(this.date).subtract(1, 'weeks').format('YYYY-MM-DD').toString()
      this.getData()
    }
  },
  components: {
    'day-button': DayButton,
    'entry-basics-dialog': EntryBasicsDialog
  }
}


</script>
